import React from "react";
import { Link } from "react-router-dom";
import { List, ListItem, ListItemIcon, ListItemText, Box } from "@mui/material";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import logo from "../../image/catalog/logonew.jpg";
import "./Sidebar.css";

const Sidebar = () => {
  return (
    <div className="sidebar">
      <div className="sidebar-logo">
        <Link to="/home">
          <img src={logo} alt="logo" className="logo" />
        </Link>
      </div>
      <List className="sidebar-menu">
        <ListItem button component={Link} to="/retailerdashboard">
          <ListItemIcon>
            <DashboardIcon />
          </ListItemIcon>
          <ListItemText primary="My Profile" />
        </ListItem>
        <ListItem button component={Link} to="/orderlist">
          <ListItemIcon>
            <i className="menu-icon tf-icons bx bx-box"></i>
          </ListItemIcon>
          <ListItemText primary="Orders" />
        </ListItem>
        <ListItem button component={Link} to="/orderidret">
          <ListItemIcon>
            <i className="menu-icon tf-icons bx bx-box"></i>
          </ListItemIcon>
          <ListItemText primary="Return" />
        </ListItem>
        {/* <ListItem button component={Link} to="/offers">
          <ListItemIcon>
            <i className="menu-icon tf-icons bx bx-box"></i>
          </ListItemIcon>
          <ListItemText primary="Offers" />
        </ListItem>
        <ListItem button component={Link} to="/payments">
          <ListItemIcon>
            <i className="menu-icon tf-icons bx bx-box"></i>
          </ListItemIcon>
          <ListItemText primary="Payments" />
        </ListItem> */}
      </List>
    </div>
  );
};

export default Sidebar;
